module.exports = {"headerColumns":{"orderDate":"Orderdatum","id":"Ordernummer","contractNumber":"Contractnummer","orderType":"Soort bestelling","status":"Status"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/order.json
// module id = pp/R
// module chunks = 1